// extracted by css-extract-rspack-plugin
export default {"tooltipV2":"tooltipV2-2HPnN","default":"default-2Hsns","label":"label-2usAQ","arrow":"arrow-2hvEu","tooltipVisible":"tooltipVisible-2W70I","tooltipHidden":"tooltipHidden-Ya-Iu"};